var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wh100"},[_c('van-cell-group',{staticClass:"cellGroup"},[_c('van-cell',{staticClass:"horCenter",attrs:{"value":"切换帐号"}})],1),_c('van-cell-group',{staticClass:"cellGroup"},[_c('van-cell',{staticClass:"horCenter",attrs:{"value":"退出登录"},on:{"click":_vm.loginout}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }